import React from 'react';
import QnADetail from '../components/setting/QnADetail';

const QnADetailPage: React.FC = () => {
  return (
    <div className="main-container">
      <QnADetail />
    </div>
  );
};

export default QnADetailPage;
